import { useEffect, useRef } from "react";

export const useAutoClose = (
	active: boolean,
	delayMs: number,
	onClose?: () => void,
) => {
	const onCloseRef = useRef(onClose);

	useEffect(() => {
		onCloseRef.current = onClose;
	});

	useEffect(() => {
		if (!active) return;
		const id = setTimeout(() => onCloseRef.current?.(), delayMs);
		return () => clearTimeout(id);
	}, [active, delayMs]);
};
